import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getAllTaskNames,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    getEmployeeTaskDetailReportData,
    GetAllOperationEntityByGroupID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function getAllTaskNames(groupID, estateID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
        array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]
        }
    }
    return array;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(estateID) {
    const response = await CommonGet('/api/EmployeeTask/GetTaskDetailByOperationEntityID', 'operationEntityID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["taskID"]] = item[1]["taskName"]

    }
    return array;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEmployeeTaskDetailReportData(data) {
    
    var model = {
        estateID: parseInt(data.estateID),
        registrationNumber: data.registrationNumber,
        fromDate: data.fromDate,
        toDate: data.toDate,
        category: parseInt(data.category),
        task: parseInt(data.task)
    };
    const response = await CommonPost('/api/EmployeeTaskDetailReport/GetEmployeeTaskDetailReportData', null, model);
    return response.data;
}

